import React, { useMemo } from 'react';
import { SiteType } from '../../../graphql/types/SiteType';
import { useWarehouseStore } from '../../../pages/central/settings/SitesSettingPage';
import { useWarehouseContext } from '../../../contexts/WarehouseContext';
import WmsSitesTree from './components/WmsSitesTree';
import WmsSitesPageBody from './components/WmsSitesPageBody';

const WmsSitesManagementPage: React.FC = () => {
    const { currentWarehouse } = useWarehouseContext();
    const { setWarehouseId } = useWarehouseStore(state => state);

    // 计算当前 Hub ID
    const currentHubId = useMemo(() => {
        if (!currentWarehouse) return undefined;

        // 确保类型转换正确
        const siteType = Number(currentWarehouse.siteType);

        if (siteType === SiteType.HUB) {
            // 当前选中的就是 Hub，直接返回 ID
            return currentWarehouse.id;
        } else if (siteType === SiteType.WAREHOUSE) {
            // 当前选中的是 Warehouse，返回其父 Hub 的 ID
            return currentWarehouse.parentSiteId;
        }

        return undefined;
    }, [currentWarehouse]);

    // 处理站点选择
    const handleSiteSelect = (siteId: string) => {
        setWarehouseId(Number(siteId));
    };

    // 如果没有当前仓库，显示加载或提示
    if (!currentWarehouse) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-gray-500">请先选择一个 Hub 或 Warehouse</div>
            </div>
        );
    }

    // 如果无法确定 Hub ID，显示提示
    if (!currentHubId) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-gray-500">无法确定当前 Hub</div>
            </div>
        );
    }

    return (
        <div className="flex h-full w-full min-w-0">
            {/* 左侧：站点树（只显示当前 Hub 及其仓库） */}
            <WmsSitesTree
                hubFilterId={currentHubId}
                onSelect={handleSiteSelect}
            />

            {/* 右侧：站点详情 */}
            <div className="flex-1 min-w-0 w-full p-4 flex flex-col gap-8">
                <WmsSitesPageBody />
            </div>
        </div>
    );
};

export default WmsSitesManagementPage;


